import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "../../styles/LangSelectGlobals.css";
import "../../styles/LangSelectStyle.css";
import "../../styles/LangSelectStyleGuide.css";

/**
 * LangSelect
 * - 全体レイアウトは既存CSSに依存
 * - ボタン間隔と文字・矢印の余白を調整
 */

export default function LangSelect() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const buttonStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '300px',
    height: '80px',
    padding: '0 26px 0 28px', // テキストと矢印の間にゆとり
    border: '1px solid #222',
    borderRadius: '40px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    marginBottom: '18px', // ボタン同士の間隔を広げる
  };

  const textStyle = {
    fontSize: '22px',
    fontWeight: '700',
    letterSpacing: '0.1em',
    color: '#111',
  };

  const arrowCircleStyle = {
    width: '44px',
    height: '44px', // 少し大きめにして余白感アップ
    borderRadius: '50%',
    backgroundColor: '#53c3e3',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const arrowIconStyle = {
    width: '20px',
    height: '20px',
    stroke: '#fff',
    strokeWidth: 3,
    fill: 'none',
  };

  const items = [
    { label: 'C+walk', path: '/takaraduka/renttutorial' },
    { label: 'WHILL', path: '/takaraduka/howtorentwhill' },
  ];

  return (
    <div className="select-language">
      <main className="select-language">
        <div className="app-container">
          <section className="app-content">
            <div className="app-logo">
              <img
                className="limot-logo"
                src="/images/logo_limot.png"
                alt="Limot logo"
                loading="lazy"
              />
            </div>

            <div className="app-description">
              <p>{t('Select your mobility')}</p>
            </div>

            <nav className="mobility-selection" aria-label={t('Mobility selection')}>
              {items.map(({ label, path }) => (
                <button
                  key={label}
                  onClick={() => navigate(path)}
                  className="language-button language-button-large"
                  aria-label={`Select ${label}`}
                  style={buttonStyle}
                >
                  <span style={textStyle}>{label}</span>
                  <div style={arrowCircleStyle}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      style={arrowIconStyle}
                    >
                      <polyline points="8 5 16 12 8 19" />
                    </svg>
                  </div>
                </button>
              ))}
            </nav>
          </section>
        </div>
      </main>
    </div>
  );
}
